/* Arma las cards "Cómpralos en conjunto" en el navegador — port JS de
   detecta_conjuntos() + ficha_conjunto() (common.py del sitio de Vercel).
   Lee el JSON de <script id="succoConjuntosDatos"> (snippets/conjuntos-datos.liquid)
   y pinta dentro de [data-conjuntos]. Debe cargar ANTES de conjunto.js, que es el
   que da vida a los chips y al botón.

   Foto por color: la card abre con la foto de cuerpo entero del conjunto y, al tocar un
   color, pasa a la foto de cuerpo entero de ese color (las tallas no cambian la foto).
   Nombres de las fotos en Shopify (mayúsculas, _ - o espacio dan igual):
     <REF1>-<REF2>_PINTA<N>       conjunto completo del look N, de frente (_FTE opcional)
     <REF1>-<REF2>_PINTA<N>_ESP   el mismo look de espalda (_E también vale)
     <REF>_PINTA<N>               la prenda sola, recorte del look N
   La foto destacada de cada variante de color (admin → variante → imagen) dice su look. */
(function(){
  var fuente = document.getElementById('succoConjuntosDatos');
  var destino = document.querySelector('[data-conjuntos]');
  if (!fuente || !destino) return;
  var D;
  try { D = JSON.parse(fuente.textContent); } catch(e){ return; }
  var REF = /\d{5}[A-Z]?/g;
  var CDN = '/cdn/shop/files/';
  var UUID = /_[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/;

  // clave de una foto: el nombre sin extensión ni el _uuid que Shopify pega a los duplicados
  function clave(n){ return String(n).toUpperCase().replace(/\.[A-Z0-9]+$/, '').replace(UUID, ''); }
  // ¿la foto trae la ref? También vale sin la letra final (43612M-23612_PINTA1)
  var reRef = {};
  function tiene(k, ref){
    if (k.indexOf(ref) !== -1) return true;
    var re = reRef[ref] || (reRef[ref] = new RegExp('(^|[^0-9])' + ref.slice(0, 5) + '(?![0-9A-Z])'));
    return re.test(k);
  }
  function esColor(nombre){
    var s = String(nombre || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return /^\s*colou?r/.test(s);
  }

  var prods = {};
  D.productos.forEach(function(q){
    q.images = q.images.map(function(n){
      var k = clave(n), m = /PINTA[_\s-]*(\d+)/.exec(k);
      return {n: n, f: n.toUpperCase(), k: k, u: CDN + n + '?width=560', look: m ? +m[1] : null,
              esp: /ESP|(^|[_\s-])E($|[_\s-])|PINTA[_\s-]*\d+E($|[_\s-])/.test(k), nref: (k.match(REF) || []).length};
    });
    q.foto = q.images.length ? CDN + q.images[0].n + '?width=240' : '';
    if (q.ref && q.available) prods[q.ref] = q;
  });

  var pares = {};
  Object.keys(prods).forEach(function(r){
    var q = prods[r], cands = {};
    var re = /[Cc]ombina con[^.<]{0,60}?(\d{5}[A-Z]?)/g, m;
    while ((m = re.exec(q.description || ''))) cands[m[1]] = 1;
    q.images.forEach(function(im){
      var refs = im.k.match(REF) || [];
      if (refs.indexOf(q.ref) !== -1) refs.forEach(function(x){ if (x !== q.ref) cands[x] = 1; });
    });
    Object.keys(cands).forEach(function(o){
      if (prods[o] && o !== q.ref) pares[[q.ref, o].sort().join('|')] = 1;
    });
  });

  // de frente antes que de espalda, luego las que traen solo estas dos refs; si no, el orden del admin
  function ordena(lista){
    return lista.map(function(im, i){ return [im, i]; }).sort(function(x, y){
      return (x[0].esp - y[0].esp) || (x[0].nref - y[0].nref) || (x[1] - y[1]);
    }).map(function(x){ return x[0]; });
  }
  // color → foto destacada de esa variante (índice "i" que manda el Liquid)
  function porColor(q){
    var gi = -1, fot = Object.create(null);
    q.options.forEach(function(o, i){ if (gi === -1 && esColor(o.name)) gi = i; });
    if (gi !== -1) q.variants.forEach(function(v){
      var c = v.o[gi];
      if (c != null && !fot[c] && typeof v.i === 'number' && q.images[v.i]) fot[c] = q.images[v.i];
    });
    return {gi: gi, fot: fot};
  }

  var conjuntos = Object.keys(pares).map(function(k){
    var rs = k.split('|'), a = prods[rs[0]], b = prods[rs[1]];
    var top = rs[0].charAt(0) === '2' ? a : b, bottom = top === a ? b : a;
    // fotos del conjunto completo: las que traen las dos refs (sin duplicados _uuid)
    var enCombo = {}, combos = [];
    [top, bottom].forEach(function(q){
      q.images.forEach(function(im){
        if (!enCombo[im.k] && tiene(im.k, top.ref) && tiene(im.k, bottom.ref)){ enCombo[im.k] = 1; combos.push(im); }
      });
    });
    combos = ordena(combos);
    var looks = {};
    combos.forEach(function(im){ if (im.look !== null && !looks[im.look]) looks[im.look] = im; });
    // fotos deslizables: la pinta completa primero (de frente), luego las otras fotos del
    // conjunto (una por look y lado) y la foto principal de cada prenda
    var lista = [], vistas = {};
    combos.concat([top.images[0], bottom.images[0]]).forEach(function(im){
      var id = im && (enCombo[im.k] && im.look !== null ? 'L' + im.look + '|' + im.nref + '|' + im.esp : im.k);
      if (im && !vistas[id]){ vistas[id] = 1; lista.push(im); }
    });
    return {top: top, bottom: bottom, foto: lista.length ? lista[0].u : '', ini: lista[0] || null,
            fotos: lista.map(function(im){ return im.u; }), looks: looks, enCombo: enCombo,
            p: [porColor(top), porColor(bottom)]};
  }).filter(function(c){ return c.top.linea === D.linea; });

  conjuntos.sort(function(x, y){
    var cx = x.top.coleccion ? 0 : 1, cy = y.top.coleccion ? 0 : 1;
    return cx - cy || (x.top.ref < y.top.ref ? -1 : x.top.ref > y.top.ref ? 1 : 0);
  });

  if (!conjuntos.length){
    var sec = destino.closest('[data-conjuntos-seccion]');
    if (sec) sec.style.display = 'none';
    return;
  }

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function cop(c){ return '$ ' + Math.round(c/100).toLocaleString('es-CO'); }
  function prenda(q){
    return {handle: q.handle, nombre: q.nombre, ref: q.ref, foto: q.foto, opts: q.options.length,
            vars: q.variants.map(function(v){ return {id: v.id, o: v.o, av: v.av, p: v.p}; })};
  }
  destino.innerHTML = conjuntos.map(function(cj, idx){
    var prendas = [cj.top, cj.bottom].map(function(q, pi){
      var chips = q.options.map(function(o, gi){
        return '<div class="cj-opt"><span class="cj-opt-n">' + esc(o.name) + '</span>' +
          o.values.map(function(v){
            return '<button class="cj-chip" data-p="' + pi + '" data-g="' + gi + '" data-v="' + esc(v) + '">' + esc(v) + '</button>';
          }).join('') + '</div>';
      }).join('');
      return '<div class="cj-prod"><a href="' + q.url + '">' + esc(q.nombre) + '</a>' +
        '<span class="cj-precio">' + cop(q.price) + '</span>' + chips + '</div>';
    }).join('');
    var datos = esc(JSON.stringify({a: prenda(cj.top), b: prenda(cj.bottom)}));
    var total = cj.top.price + cj.bottom.price;
    return '<article class="cj reveal" id="conjunto-' + idx + '" data-cj="' + datos + '">' +
      (window.succoFotos ? window.succoFotos.html(cj.fotos, {url: cj.top.url, clase: 'cj-photo',
        alt: 'Conjunto ' + cj.top.nombre + ' + ' + cj.bottom.nombre}) :
      '<a class="cj-photo" href="' + cj.top.url + '"><img src="' + cj.foto + '" alt="Conjunto ' +
      esc(cj.top.nombre) + ' + ' + esc(cj.bottom.nombre) + '" loading="lazy"></a>') +
      '<div class="cj-info"><span class="cj-kicker">Cómpralos en conjunto</span>' + prendas +
      '<div class="cj-foot"><span class="cj-total" data-total0="' + total + '">Conjunto: ' + cop(total) +
      ' <small>COP</small></span><button class="cj-add" disabled>Elige tallas para armar el conjunto</button></div>' +
      '</div></article>';
  }).join('');
  if (window.succoFotos) window.succoFotos.init(destino);

  /* ---- Foto según el color elegido ---- */
  // a) la destacada si ya es del conjunto completo (de frente si el look la tiene),
  // b) la del conjunto completo del mismo look (PINTA N), d) la de la prenda sola
  function fotoColor(cj, pi, c){
    var im = c != null ? cj.p[pi].fot[c] : null;
    if (!im) return null;
    var look = im.look !== null ? cj.looks[im.look] : null;
    if (cj.enCombo[im.k]) return (im.esp && look) ? look : im;
    return look || im;
  }
  function elegido(card, pi, gi){
    if (gi === -1) return null;
    var ch = card.querySelector('.cj-chip.on[data-p="' + pi + '"][data-g="' + gi + '"]');
    return ch ? ch.getAttribute('data-v') : null;
  }
  function fotoPara(cj, card, pi, activo){
    var col = [elegido(card, 0, cj.p[0].gi), elegido(card, 1, cj.p[1].gi)], o = 1 - pi;
    if (!activo) return (col[o] != null && fotoColor(cj, o, col[o])) || cj.ini;   // se quitó el color
    // c) las dos prendas con color y un mismo look para ambas: ese gana
    var x = cj.p[pi].fot[col[pi]], y = col[o] != null ? cj.p[o].fot[col[o]] : null;
    if (x && y && x.look !== null && x.look === y.look && cj.looks[x.look]) return cj.looks[x.look];
    return fotoColor(cj, pi, col[pi]);
  }
  function pon(card, im){
    var fc = card.querySelector('[data-fotos]');
    var track = fc && fc.querySelector('.fc-track');
    var slides = [].slice.call(track ? track.children : card.querySelectorAll('.cj-photo img'));
    // si la card ya tiene esa foto (aunque sea el duplicado _uuid), se salta a ella
    var s = slides.filter(function(x){ return clave(x.getAttribute('data-f') || '') === im.k; })[0];
    var url = s ? s.getAttribute('src') : im.u;
    var tok = card._cjFoto = (card._cjFoto || 0) + 1;
    var pre = new Image();
    pre.onload = function(){
      if (card._cjFoto !== tok) return;            // ya tocaron otro color
      if (fc && window.succoFotos && window.succoFotos.ir){
        var arch = s ? s.getAttribute('data-f') : im.n;
        window.succoFotos.ir(card, arch, s ? null : url);
        // ir() cambia el src del primer slide pero no su data-f: se deja al día
        if (!s && slides[0]) slides[0].setAttribute('data-f', arch);
      } else if (slides[0]) slides[0].src = url;
    };
    pre.src = url;
  }
  var armados = {};
  conjuntos.forEach(function(cj, idx){ armados['conjunto-' + idx] = cj; });
  // delegado en [data-conjuntos]: corre después del clic de conjunto.js en la card,
  // así el chip ya tiene (o perdió) la clase .on
  destino.addEventListener('click', function(e){
    var ch = e.target.closest ? e.target.closest('.cj-chip') : null;
    var card = ch && ch.closest('.cj'), cj = card && armados[card.id];
    if (!cj) return;
    var pi = +ch.getAttribute('data-p');
    if (+ch.getAttribute('data-g') !== cj.p[pi].gi) return;   // tallas: la foto no cambia
    var im = fotoPara(cj, card, pi, ch.classList.contains('on'));
    if (im) pon(card, im);
    // con algún color elegido la card no avanza sola: se queda en la foto de ese color
    var conColor = [0, 1].some(function(p){
      return card.querySelector('.cj-chip.on[data-p="' + p + '"][data-g="' + cj.p[p].gi + '"]');
    });
    if (window.succoFotos && window.succoFotos.fija) window.succoFotos.fija(card, conColor);
  });
})();
